export default "__VITE_ASSET__Cl24N87q__"